import type { ConfigOverrideKey } from '#dn-types/host.ts';
import type { OverrideMap } from '../../hooks/useOverrideMaps.ts';
import { makeHalves } from './makeHalves.ts';

const statsOrdering: ConfigOverrideKey[] = [
  // graphite
  'stats.host',
  'stats.prefix',
  // prometheus
  'stats.listen',
  'stats.namespace',
  'stats.path',
  'stats.subsystem',
  // shared
  'stats.interval',
  'stats.lighthouse_metrics',
  'stats.message_metrics',
];

/**
 * Sort a statsMap into the same order as the Host Advanced form, and divide it into two halves,
 * with the first half containing an extra item if there's an odd number.
 */
export function makeStatsHalves(statsMap: OverrideMap) {
  return makeHalves(statsMap, statsOrdering);
}
